export const constPaginationDataGrid = {
    defaultPageSize: 20,
    defaultPageSizesArray: [20, 50, 100]
}